import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { useGate } from 'statsig-react';
import type { Maybe } from '@soundxyz/utils';
import { Countdown } from '@components/Countdown';
import { GetNotifiedButton } from '@components/EmailNotifications/GetNotifiedButton';
import { SpotifyPresaveButton } from '@components/SpotifyPresave/SpotifyPresaveButton';
import type { CurrentListeningParty } from '@hooks/usePlayButton';
import { FEATURE_GATES } from '@utils/constants';
import { CountdownContainer, fadeDown } from './shared';

export const AnimatedCountdown = ({
  mintStartTimestamp,
  currentListeningParty,
  listeningParty,
  hideCountdown,
  small,
  artistId,
  userId,
  releaseId,
  spotifyPresaveCampaign,
}: {
  mintStartTimestamp: number;
  currentListeningParty: CurrentListeningParty;
  listeningParty: Maybe<number>;
  hideCountdown: boolean;
  small?: boolean;
  artistId?: string;
  userId?: string;
  releaseId?: string;
  spotifyPresaveCampaign?: boolean;
}) => {
  const { value: isSpotifyPresaveEnabled } = useGate(FEATURE_GATES.USE_SPOTIFY_PRESAVE);
  return (
    <AnimatePresence>
      {!hideCountdown && (
        <CountdownContainer {...fadeDown} small={small}>
          <Countdown
            mintStartTimestamp={mintStartTimestamp}
            small={small}
            currentListeningParty={currentListeningParty}
            listeningParty={listeningParty}
          />
          {!!userId && !!artistId && (
            <>
              {isSpotifyPresaveEnabled &&
              releaseId != null &&
              spotifyPresaveCampaign != null &&
              spotifyPresaveCampaign ? (
                <div className="items-align mt-[34px] flex flex-row gap-2 md:mt-0">
                  <SpotifyPresaveButton releaseId={releaseId} variant="hero" />
                  <GetNotifiedButton
                    type="presave_icon_button"
                    userId={userId}
                    artistId={artistId}
                  />
                </div>
              ) : (
                <GetNotifiedButton type="default" userId={userId} artistId={artistId} />
              )}
            </>
          )}
        </CountdownContainer>
      )}
    </AnimatePresence>
  );
};
